<template>
    <div class="promo-container">
      <div class="promo-flow">
        <h1 class="main-title">Registro Curso online Eurekers</h1>

        <!-- Login Prompt -->
        <div class="login-prompt-card" v-if="!submissionStatus.message">
          <p>¿Ya tienes una cuenta? <a href="#" @click.prevent="redirectToLogin" class="login-link">Haz click aquí para iniciar sesión</a></p>
        </div>

        <!-- Stage 1: Datos Personales -->
        <div class="stage stage-1" v-if="!submissionStatus.message">
          <h2>Crea tu Cuenta</h2>
          <form @submit.prevent="submitForm">
            <div class="form-group">
              <input 
                type="text" 
                v-model="formData.username" 
                placeholder="Nombre de Usuario" 
                @blur="checkUsernameAvailability"
                :disabled="loading.checkUsername || loading.checkWpUsername"
              />
              <span class="error-message" v-if="errors.username">{{ errors.username }}</span>
              <div class="login-prompt-card" v-if="errors.username && errors.username.includes('ya está en uso')">
                <p>Este nombre de usuario ya está en uso. <a href="#" @click.prevent="redirectToLogin" class="login-link">Inicia sesión aquí</a>.</p>
              </div>
              
              <input 
                type="email" 
                v-model="formData.email" 
                placeholder="Email" 
                @blur="checkEmailAvailability"
                :disabled="loading.checkEmail || loading.checkWpEmail"
              />
              <span class="error-message" v-if="errors.email">{{ errors.email }}</span>
              <div class="login-prompt-card" v-if="errors.email && errors.email.includes('ya está registrado')">
                <p>Este email ya está registrado. <a href="#" @click.prevent="redirectToLogin" class="login-link">Inicia sesión aquí</a>.</p>
              </div>

              <input 
                type="tel" 
                v-model="formData.phone" 
                placeholder="Teléfono Móvil" 
              />
              <span class="error-message" v-if="errors.phone">{{ errors.phone }}</span>

              <input 
                type="password" 
                v-model="formData.password" 
                placeholder="Contraseña"
                @input="validatePassword" 
              />
              <span class="error-message" v-if="errors.password">{{ errors.password }}</span>

              <input 
                type="password" 
                v-model="formData.confirmPassword" 
                placeholder="Confirmar Contraseña"
                @input="validateConfirmPassword" 
              />
              <span class="error-message" v-if="errors.confirmPassword">{{ errors.confirmPassword }}</span>

              <div class="checkbox-group">
                <label>
                  <input type="checkbox" v-model="formData.mailing" />
                  Deseo recibir comunicaciones comerciales.
                </label>
              </div>

              <div class="checkbox-group">
                <label :class="{ 'error-label': errors.lopd }">
                  <input type="checkbox" v-model="formData.lopd" />
                  He leído y acepto la <a href="/politica-de-privacidad" target="_blank">política de privacidad</a> (LOPD). *
                </label>
                <span class="error-message" v-if="errors.lopd">{{ errors.lopd }}</span>
              </div>
              
              <span class="error-message" v-if="errors.form">{{ errors.form }}</span>
            </div>
            <div class="navigation-buttons">
              <button type="submit" class="primary-btn" :disabled="loading.submitForm || loading.wpUserCreation || Boolean(errors.email) || Boolean(errors.username) || Boolean(errors.password) || Boolean(errors.confirmPassword)">
                {{ loading.submitForm ? 'Procesando...' : (loading.wpUserCreation ? 'Creando usuario en curso...' : 'Crear Cuenta') }}
              </button>
            </div>
          </form>
        </div>
        
        <!-- Completion Message -->
        <div v-if="submissionStatus.message" class="stage stage-completion">
          <h2>{{ submissionStatus.success ? '¡Completado!' : 'Ha ocurrido un error' }}</h2>
          <div class="completion-container" :class="{ 'error-container': !submissionStatus.success }">
            <div class="icon" v-if="submissionStatus.success">
              <i class="material-icons">check_circle</i>
            </div>
            <div class="icon error-icon" v-if="!submissionStatus.success">
              <i class="material-icons">error</i>
            </div>
            <p>{{ submissionStatus.message }}</p>
          </div>
           <div class="navigation-buttons centered" v-if="submissionStatus.success">
            <button class="primary-btn highlight-btn" @click="goToLogin" v-if="submissionStatus.message.includes('inicia sesión') || submissionStatus.message.includes('autenticación de dos factores')">
              Ir a Login
            </button>
          </div>
          <div class="navigation-buttons centered" v-if="!submissionStatus.success">
            <button class="primary-btn highlight-btn" @click="resetForm">
              Volver a intentar
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios"; // Added import for axios
  export default {
    name: 'PromoView',
    data() {
      return {
        //LoginSteps: Object.freeze({ // Consider if needed, or if redirect is enough
        //  LOGIN: 0,
        //  TWO_FACTOR: 1, // Unlikely to be handled here, but for completeness
        //  LOGGED: 2
        //}),
        //currentLoginStep: 0, // To track login process after registration
        loadingLogin: false, // For login process
        formData: {
          username: '',
          email: '',
          phone: '',
          password: '',
          confirmPassword: '',
          mailing: false,
          lopd: false,
        },
        errors: {
          username: '',
          email: '',
          phone: '',
          password: '',
          confirmPassword: '',
          lopd: '',
          form: '',
        },
        loading: {
          submitForm: false,
          checkEmail: false,
          checkUsername: false,
          checkWpEmail: false, // Added for curso online email check
          checkWpUsername: false, // Added for curso online username check
          wpUserCreation: false, // Added for curso online user creation
        },
        submissionStatus: {
          success: false,
          message: '',
        }
      };
    },
    computed: { // Added computed property for wpApiBaseUrl
      wpApiBaseUrl() {
        return 'https://online.eurekers.com/wp-json/eurekers-custom/v1';
      }
    },
    methods: {
      async checkEmailAvailability() {
        const email = this.formData.email.trim();
        this.errors.email = '';

        if (!email) {
          return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          this.errors.email = 'Por favor, introduce un email válido.';
          return;
        }

        this.loading.checkEmail = true;
        this.loading.checkWpEmail = true; // Start WP loading
        try {
          // Drupal check
          const response = await fetch(`/api/informe/check-email?email=${encodeURIComponent(email)}`);
          if (!response.ok) {
            console.error('Drupal email check HTTP error:', response.status);
            this.errors.email = 'No se pudo verificar tu email en este momento. Inténtalo de nuevo.'; 
          }
          const data = await response.json();
          if (data.error) {
            if (data.error.includes('ya está registrado') || data.error.includes('already registered')) {
                this.errors.email = 'Este email ya está registrado. Por favor, utiliza otro.';
            } else {
                console.error('Drupal email check API error:', data.error);
                this.errors.email = 'Hubo un problema al verificar tu email. Por favor, inténtalo más tarde.';
            }
          } else if (data.available === false) {
            this.errors.email = 'Este email ya está registrado. Por favor, utiliza otro.';
          } else {
            this.errors.email = ''; // Clear Drupal specific error if any
          }

          // curso online Check - only if Drupal check passed or no specific "unavailable" error
          if (!this.errors.email || (this.errors.email && !this.errors.email.includes('ya está registrado'))) {
            try {
              const wpResponse = await axios.get(`${this.wpApiBaseUrl}/user-exists`, {
                params: { email: email }
              });
              if (wpResponse.data && wpResponse.data.exists) {
                // If Drupal check didn't find it, but WP did
                if (!this.errors.email) {
                    this.errors.email = 'Este email ya está en uso en la plataforma del curso. Por favor, elige otro.';
                } else {
                    // If Drupal had a generic error, but WP confirms it exists, make it more specific
                     this.errors.email = 'Este email ya está en uso. Por favor, elige otro.';
                }
              }
              // If WP says it does not exist, and Drupal check was fine, errors.email remains empty.
            } catch (wpError) {
              console.error('Error checking email on curso online:', wpError);
              // Do not overwrite a Drupal error if WP check fails.
              // If Drupal check was OK, can set a generic WP error or let it pass.
              // For now, we'll let it pass and rely on backend validation during creation if WP check fails here.
              // if (!this.errors.email) {
              //   this.errors.email = 'No se pudo verificar el email en la plataforma del curso.';
              // }
            }
          }
        } catch (error) {
          console.error('Error checking email (Drupal):', error);
          if (!this.errors.email) { // Avoid overwriting a more specific error
            if (error.message && error.message.includes('Failed to fetch')) {
                this.errors.email = 'No se pudo conectar con el servidor para verificar el email. Revisa tu conexión.';
            } else {
                this.errors.email = 'No se pudo verificar tu email en este momento. Inténtalo de nuevo más tarde.';
            }
          }
        } finally {
          this.loading.checkEmail = false;
          this.loading.checkWpEmail = false; // End WP loading
        }
      },

      async checkUsernameAvailability() {
        const username = this.formData.username.trim();
        this.errors.username = '';

        if (!username) {
          return;
        }

        if (username.length < 3 || username.length > 60) {
          this.errors.username = 'El nombre de usuario debe tener entre 3 y 60 caracteres.';
          return;
        }
        if (!/^[a-zA-Z0-9_]+$/.test(username)) {
          this.errors.username = 'El nombre de usuario solo puede contener letras, números y guiones bajos.';
          return;
        }

        this.loading.checkUsername = true;
        this.loading.checkWpUsername = true; // Start WP loading
        try {
          // Drupal Check
          const response = await fetch(`/api/informe/check-username?username=${encodeURIComponent(username)}`);
          if (!response.ok) {
            console.error('Drupal username check HTTP error:', response.status);
            this.errors.username = 'No se pudo verificar tu nombre de usuario. Inténtalo de nuevo.';
          }
          const data = await response.json();
          if (data.error) {
            if (data.error.includes('ya está en uso') || data.error.includes('already in use')) {
                this.errors.username = 'Este nombre de usuario ya está en uso. Por favor, elige otro.';
            } else {
                console.error('Drupal username check API error:', data.error);
                this.errors.username = 'Hubo un problema al verificar tu nombre de usuario. Por favor, inténtalo más tarde.';
            }
          } else if (data.available === false) {
            this.errors.username = 'Este nombre de usuario ya está en uso. Por favor, elige otro.';
          } else {
            this.errors.username = ''; // Clear Drupal specific error
          }

          // curso online Check - only if Drupal check passed or no specific "unavailable" error
          if (!this.errors.username || (this.errors.username && !this.errors.username.includes('ya está en uso'))) {
            try {
              const wpResponse = await axios.get(`${this.wpApiBaseUrl}/user-exists`, {
                params: { username: username }
              });
              if (wpResponse.data && wpResponse.data.exists) {
                if (!this.errors.username) {
                    this.errors.username = 'Este nombre de usuario ya está en uso en la plataforma del curso. Por favor, elige otro.';
                } else {
                    this.errors.username = 'Este nombre de usuario ya está en uso. Por favor, elige otro.';
                }
              }
            } catch (wpError) {
              console.error('Error checking username on curso online:', wpError);
              // if (!this.errors.username) {
              //   this.errors.username = 'No se pudo verificar el nombre de usuario en la plataforma del curso.';
              // }
            }
          }
        } catch (error) {
          console.error('Error checking username (Drupal):', error);
          if(!this.errors.username) {
            if (error.message && error.message.includes('Failed to fetch')) {
                this.errors.username = 'No se pudo conectar con el servidor para verificar el usuario. Revisa tu conexión.';
            } else {
                this.errors.username = 'No se pudo verificar tu nombre de usuario en este momento. Inténtalo de nuevo más tarde.';
            }
          }
        } finally {
          this.loading.checkUsername = false;
          this.loading.checkWpUsername = false; // End WP loading
        }
      },

      validatePassword() {
        const password = this.formData.password.trim();
        this.errors.password = '';
        
        if (!password) {
          this.errors.password = 'La contraseña es obligatoria.';
        } else if (password.length < 6) {
          this.errors.password = 'La contraseña debe tener al menos 6 caracteres.';
        }
        
        // If confirm password is already filled, validate it again when password changes
        if (this.formData.confirmPassword) {
          this.validateConfirmPassword();
        }
      },
      
      validateConfirmPassword() {
        const password = this.formData.password.trim();
        const confirmPassword = this.formData.confirmPassword.trim();
        this.errors.confirmPassword = '';
        
        if (!confirmPassword) {
          this.errors.confirmPassword = 'Por favor confirma tu contraseña.';
        } else if (password !== confirmPassword) {
          this.errors.confirmPassword = 'Las contraseñas no coinciden.';
        }
      },

      validateForm() {
        this.errors.username = !this.formData.username.trim() ? 'El nombre de usuario es obligatorio.' : this.errors.username;
        if (!this.errors.username && (this.formData.username.trim().length < 3 || this.formData.username.trim().length > 60)) {
            this.errors.username = 'El nombre de usuario debe tener entre 3 y 60 caracteres.';
        }
        if (!this.errors.username && !/^[a-zA-Z0-9_]+$/.test(this.formData.username.trim())) {
            this.errors.username = 'El nombre de usuario solo puede contener letras, números y guiones bajos.';
        }

        this.errors.email = !this.formData.email.trim() ? 'El email es obligatorio.' : this.errors.email;
        if (!this.errors.email && !/^[\w\.-]+@[\w\.-]+\.\w{2,4}$/.test(this.formData.email.trim())) {
            this.errors.email = 'Por favor, introduce un email válido.';
        }

        this.errors.phone = !this.formData.phone.trim() ? 'El teléfono es obligatorio.' : '';
        if (!this.errors.phone && !/^[67][0-9]{8}$/.test(this.formData.phone.trim())) {
            this.errors.phone = 'Introduce un número de teléfono móvil español válido (9 dígitos comenzando por 6 o 7).';
        }

        this.validatePassword();
        this.validateConfirmPassword();

        this.errors.lopd = !this.formData.lopd ? 'Debes aceptar la política de privacidad.' : '';
        
        return !this.errors.username && !this.errors.email && !this.errors.phone && !this.errors.password && !this.errors.confirmPassword && !this.errors.lopd;
      },

      async submitForm() {
        this.errors.form = '';
        this.submissionStatus.message = '';

        if (!this.validateForm()) {
          return;
        }
        
        if (this.errors.email) { // From async check
            return;
        }

        this.loading.submitForm = true;
        try {
          const response = await fetch('/api/informe/create-user-simple', { 
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            withCredentials: true,
            body: new URLSearchParams({
              username: this.formData.username.trim(),
              email: this.formData.email.trim(),
              phone: this.formData.phone.trim(),
              password: this.formData.password.trim(),
              mailing: this.formData.mailing,
              lopd: this.formData.lopd,
            }),
          });

          const data = await response.json();

          if (!response.ok || !data.success) {
            this.submissionStatus.success = false;
            this.submissionStatus.message = data.error || 'Error al registrar el usuario. Por favor, inténtelo de nuevo.';
            this.loading.submitForm = false; // Stop loading here if Drupal fails
            return; // Important to return
          } else {
            // Drupal Registration was successful, now attempt curso online user creation
            this.loading.wpUserCreation = true;
            const wpRestApiUrl = 'https://online.eurekers.com/wp-json/eurekers-custom/v1/create-user-from-drupal';
            const wpPayload = {
              email: this.formData.email.trim(),
              password: this.formData.password.trim(), // Sending plain password
            };
            const wpConfig = {
              headers: {
                'Content-Type': 'application/json',
              }
            };

            try {
              const wpResponse = await axios.post(wpRestApiUrl, wpPayload, wpConfig);
              // Check for a 2xx status (implicit in axios promise resolution) 
              // and the presence of user_id in the response data as an indicator of success.
              if (wpResponse.data && wpResponse.data.user_id) {
                console.log('curso online user created successfully:', wpResponse.data.message);
                // Both Drupal and curso online user creation successful, now attempt auto-login for Drupal
                await this.attemptAutoLogin();
                // The submissionStatus message will be set by handleLoginResponse
              } else {
                // curso online user creation failed
                console.error('curso online user creation failed:', wpResponse.data ? wpResponse.data.message : 'Unknown error from curso online endpoint');
                this.submissionStatus.success = true; // Drupal registration was successful
                this.submissionStatus.message = '¡Te has registrado correctamente en Eurekers! Sin embargo, hubo un problema al crear tu cuenta en la plataforma del curso online. Por favor, contacta con soporte para acceder al curso. Ya puedes iniciar sesión en Eurekers.';
                // Do not proceed to auto-login if WP creation failed. User can click "Ir a Login" for Drupal.
              }
            } catch (wpError) {
              console.error('Axios error during curso online user creation:', wpError);
              let wpErrorMessage = 'Error al crear el usuario en la plataforma del curso online.';
              if (wpError.response && wpError.response.data && wpError.response.data.message) {
                  wpErrorMessage = wpError.response.data.message;
              } else if (wpError.request) {
                  wpErrorMessage = 'No se recibió respuesta del servidor de la plataforma del curso online.';
              } else if (wpError.message) {
                  wpErrorMessage = 'Ocurrió un problema técnico al intentar crear tu cuenta en la plataforma del curso online. Por favor, contacta con soporte.';
              }
              this.submissionStatus.success = true; // Drupal registration was successful
              this.submissionStatus.message = `¡Te has registrado correctamente en Eurekers! Sin embargo, ${wpErrorMessage}. Por favor, contacta con soporte para acceder al curso. Ya puedes iniciar sesión en Eurekers.`;
            } finally {
              this.loading.wpUserCreation = false;
            }
          }
        } catch (error) {
          console.error('Error submitting form (Drupal part):', error);
          this.submissionStatus.success = false;
          if (error.message && error.message.includes('Failed to fetch')) {
            this.submissionStatus.message = 'No se pudo conectar con el servidor para completar el registro. Por favor, revisa tu conexión a internet e inténtalo de nuevo.';
          } else {
            this.submissionStatus.message = 'Error al registrar el usuario. Por favor, inténtelo de nuevo o contacte con soporte si el problema persiste.';
          }
        } finally {
          this.loading.submitForm = false; // Ensure this is set regardless of success/failure of Drupal/WP calls
        }
      },
      async attemptAutoLogin() {
        this.loadingLogin = true;
        const loginUrl = process.env.VUE_APP_API + '/auth/login';
        try {
          const params = new URLSearchParams();
          params.append('user', this.formData.username.trim());
          params.append('pass', this.formData.password.trim());
          const response = await axios.post(loginUrl, params);
          this.handleLoginResponse(response.data);
        } catch (error) {
          console.error('Error during auto-login:', error);
          this.submissionStatus.success = true; // Registration was successful
          this.submissionStatus.message = '¡Te has registrado correctamente! No pudimos iniciar sesión automáticamente. Por favor, dirígete a la página de inicio de sesión e ingresa tus credenciales.';
          // It's important to set submissionStatus.success to true here because registration DID succeed.
          // The message indicates that only auto-login failed.
        } finally {
          this.loadingLogin = false;
        }
      },

      handleLoginResponse(response) {
        if (response.successful_login) {
          if (response.needs_2fa) {
            this.submissionStatus.success = true; // Registration was successful
            this.submissionStatus.message = '¡Te has registrado correctamente! Se requiere autenticación de dos factores. Serás redirigido a la página de login.';
            // No automatic redirect here, user will click the button to go to login
          } else {
            this.submissionStatus.success = true;
            this.submissionStatus.message = '¡Registro e inicio de sesión correctos! Redirigiendo a la aplicación...';
            // Potentially commit to Vuex store if needed:
            // if (response.user_identity && this.$store) {
            //   this.$store.commit('setCurrentUserIdentity', response.user_identity);
            // }
            setTimeout(() => {
              // Redirect to dashboard or main app page
              const urlParams = new URLSearchParams(window.location.search);
              const rdParam = urlParams.get('rd');
              let redirectUrl = 'https://online.eurekers.com'; // Default redirect

              if (rdParam === 'rca') {
                redirectUrl = 'https://online.eurekers.com/curso-inicial-eurekers/';
              } else if (rdParam === 'rcb') {
                redirectUrl = 'https://online.eurekers.com/curso-avanzado-eurekers/';
              }

              window.location.href = redirectUrl; // Or use this.$router.push({ path: redirectUrl }); if using Vue Router for external URLs (less common)
            }, 2000); // Delay for user to read message
          }
        } else {
          this.submissionStatus.success = true; // Registration was successful
          this.submissionStatus.message = '¡Te has registrado correctamente! Sin embargo, el inicio de sesión automático falló con las credenciales proporcionadas. Por favor, inicia sesión manualmente.';
        }
      },
      resetForm(clearSubmissionStatus = true) {
        this.formData = {
          username: '',
          email: '',
          phone: '',
          password: '',
          confirmPassword: '',
          mailing: false,
          lopd: false,
        };
        this.errors = {
          username: '',
          email: '',
          phone: '',
          password: '',
          confirmPassword: '',
          lopd: '',
          form: '',
        };
        if (clearSubmissionStatus) {
            this.submissionStatus = { success: false, message: '' };
        }
      },
      goToLogin() {
        this.$router.push({ name: 'Login' }); // Assuming 'Login' is the name of your login route
      },
      redirectToLogin() {
        // const urlParams = new URLSearchParams(window.location.search);
        // const rdParam = urlParams.get('rd');
        // let loginUrl = '/app/login'; // Base path to Login.vue component

        // if (rdParam) {
        //   loginUrl += `?rd=${encodeURIComponent(rdParam)}`;
        // }
        // window.location.href = loginUrl;
        window.location.href = 'https://online.eurekers.com/login-course';
      }
    },
  };
  </script>

  <style lang="scss" scoped>
  // Styles are heavily inspired by InformeFlow.vue for consistency
  .promo-container {
    display: flex;
    min-height: 100vh;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    background-color: var(--color-background-page); // Assuming a page background color
  }
  
  .promo-flow {
    max-width: 500px; // Slightly smaller width
    width: 100%;
    padding: 30px; // More padding
    background-color: var(--color-surface);
    border-radius: 12px; // Softer radius
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1); // Softer shadow
    color: var(--color-text-primary);
  }
  
  .main-title {
    font-size: 26px; // Larger title
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
    color: var(--primary);
  }
  
  h2 {
    font-size: 22px; // Larger subtitle
    font-weight: 600;
    margin-bottom: 25px;
    text-align: center;
    color: var(--color-text-primary);
  }
  
  .stage { // Single stage, so no complex progress indicator needed
    display: flex;
    flex-direction: column;
    gap: 20px; // Increased gap
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
    gap: 15px; // Increased gap
    background-color: var(--color-background); // Using a distinct background for form group
    padding: 25px;
    border-radius: 10px;
    margin-bottom: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  
  input {
    padding: 14px 18px; // Larger padding
    border: 1px solid var(--color-outline);
    border-radius: 8px;
    font-size: 15px; // Slightly larger font
    background-color: var(--color-background);
    color: var(--color-text-primary);
    transition: border-color 0.3s, box-shadow 0.3s;
    
    &:focus {
      border-color: var(--primary);
      outline: none;
      box-shadow: 0 0 0 4px rgba(0, 174, 221, 0.15); // More prominent focus
    }
    
    &::placeholder {
      color: var(--color-text-inactive);
    }
  }
  
  button.primary-btn {
    padding: 14px 20px; // Larger padding
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600; // Bolder font
    font-size: 16px; // Larger font
    transition: all 0.2s ease;
    background-color: var(--primary);
    color: var(--color-text-on-highlight);
    width: 100%; // Full width button
    
    &:hover:not(:disabled) {
      background-color: #0098c4; // Slightly darker hover
      transform: translateY(-1px); // Subtle hover effect
    }
    
    &:disabled {
      background-color: var(--color-muted);
      cursor: not-allowed;
      opacity: 0.7; // Slightly more opaque when disabled
    }
  }
  
  .navigation-buttons {
    display: flex;
    justify-content: center; // Center the single button
    margin-top: 20px;
    
    &.centered {
      justify-content: center;
    }
    
    button {
      min-width: 150px; // Minimum width for the button
    }
  }
  
  .error-message {
    color: var(--error);
    font-size: 13px;
    font-weight: 500;
    margin-top: -5px; // Adjust margin to be closer to input
    margin-bottom: 5px;
  }
  
  .completion-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgba(67, 160, 71, 0.08); // Softer success background
    padding: 35px; // More padding
    border-radius: 10px;
    margin: 25px 0;
    border: 1px solid var(--success);
    
    .icon {
      font-size: 72px; // Larger icon
      color: var(--success);
      margin-bottom: 20px;
      
      i {
        font-size: inherit; // Inherit size
      }
    }
    
    p {
      font-size: 17px; // Larger text
      text-align: center;
      line-height: 1.6;
      color: var(--color-text-primary);
    }
  }
  
  .error-container {
    background-color: rgba(244, 67, 54, 0.08) !important; // Softer error background
    border: 1px solid var(--error);
    
    .error-icon {
      color: var(--error);
    }
     p {
      color: var(--color-text-primary); // Ensure text is readable
    }
  }
  
  .highlight-btn { // For "Go to Login" or "Try Again"
    font-size: 16px;
    font-weight: 600;
    padding: 14px 25px;
    min-width: 180px;
    transition: all 0.3s ease;
    // Using primary button styles, can be customized further if needed
    // box-shadow: 0 4px 10px rgba(0, 174, 221, 0.2);
    
    // &:hover {
    //   transform: translateY(-2px);
    //   box-shadow: 0 6px 12px rgba(0, 174, 221, 0.3);
    // }
  }
  
  @media (max-width: 767px) {
    .promo-flow {
      margin: 20px;
      padding: 20px;
    }
    
    .main-title {
        font-size: 22px;
    }
    h2 {
        font-size: 20px;
    }
    input {
        padding: 12px 15px;
        font-size: 14px;
    }
    button.primary-btn {
        padding: 12px 18px;
        font-size: 15px;
    }
    .completion-container {
        padding: 25px;
        .icon {
            font-size: 60px;
        }
        p {
            font-size: 15px;
        }
    }
  }

  .stage-1 { // Added to ensure it hides when completion message shows
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  h2 {
    // ... existing code ...
  }

  input[type="checkbox"] {
    margin-right: 8px;
    accent-color: var(--primary); // Styles the check itself
    width: auto; // Override general input width
    height: auto; // Override general input height
    vertical-align: middle;
  }

  .checkbox-group {
    display: flex;
    flex-direction: column; // To stack label and error message
    align-items: flex-start; // Align items to the start
    margin-bottom: 5px; // Space between checkbox groups
    
    label {
      display: flex; // Changed to flex for better alignment of checkbox and text
      align-items: center; // Vertically center checkbox with text
      font-size: 14px;
      color: var(--color-text-secondary);
      cursor: pointer;
      
      a {
        color: var(--primary);
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .error-label { // Style for label when there's an error with LOPD
        color: var(--error); // Make label text red
    }
    // Error message for checkbox group will be handled by the span.error-message if needed below it.
    // But for LOPD, it's good to have the label itself also indicate error.
  }

  .login-prompt-card {
    background-color: var(--color-active-surface);
    padding: 10px 15px;
    border-radius: 8px;
    margin-bottom: 20px; // Keep margin for standalone prompt
    margin-top: 5px; // Add margin-top for prompts below inputs
    text-align: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    font-size: 14px;
  }

  .login-prompt-card p {
    margin: 0;
    color: var(--color-text-secondary);
  }

  .login-prompt-card .login-link {
    color: var(--primary);
    font-weight: 600;
    text-decoration: none;
  }

  .login-prompt-card .login-link:hover {
    text-decoration: underline;
  }
  </style> 